import React from 'react'
import Map, {   Marker } from 'react-map-gl';
// import pin from "../images/pin.svg";
import marker from '../images/marker.png'
import "mapbox-gl/dist/mapbox-gl.css";


const accessToken = 'pk.eyJ1IjoieW91c2FmamFtaWwiLCJhIjoiY2t6ejluejhzMDg1NjNpbWxpbm84cjY1MSJ9.iMvIZfJ36cK2nH2r2CxErw'
const LocationMap = () => {

  // const layerStyle = {
  //   id: 'point',
  //   type: 'circle',
  //   paint: {
  //     'circle-radius': 13,
  //     'circle-color': '#007cbf'
  //   }
  // };
  return (
    <div className='container-fluid'>

      <div className='row'>
        <div className='col-lg-12 col-sm-10'>
          <Map
            mapboxAccessToken={accessToken}
            initialViewState={{
              longitude: 54.49678478388873,
              latitude: 24.372418458943596,
              zoom: 10
            }}
            style={{ width: window.width, height: 600 }}
            mapStyle="mapbox://styles/mapbox/streets-v9"
          >
            <Marker longitude={54.49678478388873} latitude={24.372418458943596} anchor="center" >
              <img src={marker} style={{ height: '30px', width: '8px' }} alt='' />
            </Marker>

          </Map>;
        </div>
      </div>
    </div>
  )
}

export default LocationMap